/**
 * Error component
 */

/** Dependencies -------------------------------------------- */

// External

import classNames from 'classnames'

// Internal

import { getPlugin } from '../dictionary'
import { useAppState } from '../state'

import Icon from './icon'

/** Main ---------------------------------------------------- */

const baseClassName = 'error'

export default function Error() {

    const plugin = getPlugin()
    const isError = useAppState( ( state ) => state.isError )

    const consolidatedClassName = classNames(
        baseClassName,
        { 'is-active': isError }
    )

    return (
        <div className={ consolidatedClassName }>
            <div className={ `${baseClassName}__container` }>
                <Icon type="alert" className={ `${baseClassName}__icon` }/>
                <h2 className={ `${baseClassName}__heading` }>Error Loading Development Data</h2>
                <p className={ `${baseClassName}__message` }>Please try again later. If issues persist, please contact <a href={ `mailto:${plugin.supportContact}` }>{ plugin.supportContact }</a> for assistance.</p>
            </div>            
        </div>
    )
}
